import Vue from './vue.js';

//Remove this from prod
//Vue.config.productionTip = false;
//Vue.config.devtools = true;

window.addEventListener("load", (event) => {
    const donation_highlights = document.querySelectorAll("section.donation-highlight");

    if (donation_highlights) {
        donation_highlights.forEach(highlight => {
            donation_highlight_init(highlight);
        })
    }
})

function donation_highlight_init(el) {
    if (!el) {
        return;
    }

    var app = new Vue({
        el: el,
        data: {
            modelDonationCampaign: null,
            modelSelectedDonationCampaign: null,
            modelDonationType: null,
            modelDonationAmount: null,
            modelDonationAmountCustom: null,
        },
        mounted: function () {
            //Set default donation type
            const donationTypes = this.$el.dataset.defaultType;
            if (donationTypes) {
                this.modelDonationType = donationTypes;
            }

            console.log(this.modelDonationType);

            //Set default donation amount
            const donationAmounts = this.$el.querySelectorAll('input[name="donation_amount"]');
            if (donationAmounts) {
                this.modelDonationAmount = donationAmounts[0].value;
            }
        },
        watch: {
            modelDonationType: function (newType) {
                const donationAmountsSingle = this.$el.querySelectorAll('.donation-amounts__single input[name="donation_amount"]');
                const donationAmountsSub = this.$el.querySelectorAll('.donation-amounts__subscription input[name="donation_amount"]');

                if (newType === 'single' && donationAmountsSingle) {
                    this.modelDonationAmount = donationAmountsSingle[0].value;
                }

                if (newType === 'subscription' && donationAmountsSub) {
                    this.modelDonationAmount = donationAmountsSub[0].value;
                }
            },
        },
        computed: {
            //Return formatted donation info
            donationCampaign: function () {
                return this.modelDonationCampaign
            },
            donationType: function () {
                return this.modelDonationType
            },
            donationAmount: function () {
                let donationAmount = this.modelDonationAmount;

                if (donationAmount === 'custom') {
                    donationAmount = this.modelDonationAmountCustom;
                }

                return parseInt(donationAmount);
            },
        },
        methods: {
            customAmountMin: function () {
                const customAmount = this.$refs.custom_amount
                if (customAmount) {
                    const customAmountMin = customAmount.getAttribute("min");
                    return parseInt(customAmountMin);
                }

                return 1;
            },
            submit: function (e) {
                const donationCampaign = this.donationCampaign;
                const donationType = this.donationType;
                const donationAmount = this.donationAmount;
                const minAmount = this.customAmountMin();

                console.log("Submit");

                if (!donationAmount) {
                    console.error("Donation amount not set");
                    return;
                }

                if (donationAmount < minAmount) {
                    console.error("Donation amount not large enough");
                    return;
                }

                // Generate a form to send data to gf-donation-form

                var f = document.createElement('form');
                const host = window.location.hostname;
                f.action = 'https://' + host + '/lahjoituslomake/';
                f.method = 'POST';

                //Donation campaign
                var donation_campaign = document.createElement('input');
                donation_campaign.type = 'hidden';
                donation_campaign.name = 'donation_campaign';
                donation_campaign.value = donationCampaign;
                f.appendChild(donation_campaign);

                //Donation type
                var donation_type = document.createElement('input');
                donation_type.type = 'hidden';
                donation_type.name = 'donation_type';
                donation_type.value = donationType;
                f.appendChild(donation_type);

                //Donation amount
                var donation_amount = document.createElement('input');
                donation_amount.type = 'hidden';
                donation_amount.name = 'donation_amount';
                donation_amount.value = donationAmount;
                f.appendChild(donation_amount);

                document.body.appendChild(f);
                f.submit();

                // Clean up the form after submission
                document.body.removeChild(f);



                //Form query string for redirect
                /*
                const params = new URLSearchParams();
                params.append("campaign", donationCampaign);
                params.append("type", donationType);
                params.append("amount", donationAmount);
                const querystring = "?" + params.toString();

                console.log(querystring);
                */
            }
        },
        directives: {
            'default-value': {
                // directive definition
                inserted: (el, binding, vnode) => {
                    if (binding.value) {
                        vnode.context.modelDonationCampaign = binding.value
                    }
                }
            }
        }
    })
}